export default __webpack_public_path__ + "static/media/vanilla_gelato.596d07c7.jpg";